import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const HomepageBigPromise = ({ homePageBannerImage }) => {
  return (
    <section className="homepage-jumbotron" aria-label="Homepage Big Promise">
      <div
        className="big-promise"
        style={{
          position: 'relative',
          backgroundImage: 'url(' + homePageBannerImage + ')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          WebkitBackgroundSize: 'cover',
          MozBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
          padding: 0,
          textAlign: 'center',
          height: '475px',
          boxSizing: 'border-box',
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>
              <FormattedMessage
                id="homepage.bigPromise.title"
                defaultMessage="Discover, Save and Charge Ahead."
              />
            </h1>
            <p>
              <FormattedMessage
                id="homepage.bigPromise.description"
                defaultMessage="This guide can help you make an informed decision by providing detailed info on EVs, savings and charging."
              />
            </p>
            <ul className="banner-links">
              <li>
                <a href="/vehicles">
                  <FormattedMessage
                    id="homepage.bigPromise.findYourEvMatch"
                    defaultMessage="Find Your EV Match"
                  />
                </a>
              </li>
              <li>
                <a href="/incentives">
                  <FormattedMessage
                    id="homepage.bigPromise.seeYourRebates"
                    defaultMessage="See Your Rebates"
                  />
                </a>
              </li>
              <li>
                <a href="/charging-stations">
                  <FormattedMessage
                    id="homepage.bigPromise.howChargingWorks"
                    defaultMessage="How Charging Works"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomepageBigPromise;

HomepageBigPromise.propTypes = {
  homePageBannerImage: PropTypes.string,
};
